// @flow
import React from "react";
import { Field } from "redux-form";

import RadioButtonReusable from "modules/ShortOfferForm/components/SubComponents/RadioButtonReusable";
import i18n from "../../../../../i18n";

type Props = {
  ariaLabelledby: string,
  name: string,
  normalize?: Function,
  format?: Function,
  className?: string,
};

const RadioButtonOptions = ({ ariaLabelledby, name, normalize, format, className, ...otherProps }: Props) => (
  <div role="radiogroup" aria-labelledby={ariaLabelledby} className={className}>
    <Field
      {...otherProps}
      name={name}
      data-cy={name}
      component={RadioButtonReusable}
      labels={[i18n.t("common:yes"), i18n.t("common:no")]}
      normalize={normalize}
      format={format}
      values={["yes", "no"]}
      inline
    />
  </div>
);

export default RadioButtonOptions;
